module.exports = __webpack_public_path__ + "static/forecast/weather/daysnowshowers-de83baaff2d8e17ae06f117a2bfd74ad.svg";